if (!customElements.get('rd-sample-link')) {
  customElements.define('rd-sample-link', class extends HTMLElement {
    connectedCallback() {
      this.main = this.closest('main');
      this.productInfo = this.closest('product-info');
      if (!this.main || !this.productInfo?.id.startsWith('MainProduct-') || this.productInfo.dataset.updateUrl !== 'true') return;
      this.sync = () => {
        const gallery = Array.from(this.main.querySelectorAll('rd-sample-gallery[id]')).find((candidate) =>
          candidate.dataset.productId === this.dataset.productId && candidate.querySelector('[data-photo]')
        );
        const current = this.querySelector('a');
        if (!gallery || this.productInfo.dataset.productId !== this.dataset.productId) {
          if (current) current.remove();
          this.hidden = true;
          return;
        }
        const href = `#${gallery.id}`;
        if (!current) {
          const link = document.createElement('a');
          link.href = href;
          link.textContent = this.dataset.label;
          this.append(link);
        } else if (current.getAttribute('href') !== href) {
          current.setAttribute('href', href);
        }
        this.hidden = false;
      };
      this.sync();
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, { childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
